/// <amd-module name="Build/Flux/Sources/Contribution" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IConstributionSourceOptions {
    pageContext: IVssPageContext;
}

export class ContributionSource {
    private _pageContext: IVssPageContext;

    constructor(options: IConstributionSourceOptions) {
        this._pageContext = options.pageContext;
    }

    /**
     * @param T Type to retrieve from the contribution source.
     * Decorate your C# return type with [ClientIncludeModel] and
     * genclient will create a type in Build/Client/Contracts/DataProvider.d.ts.
     */
    public getDataAsync<T = { [key: string]: any }>(contributionId: string, routeValues?: { [key: string]: string }, refresh: boolean = false) {
        return this._service.getDataAsync<T>(contributionId, routeValues, refresh);
    }

    /**
     * @param T Type to retrieve from the contribution source.
     * Decorate your C# return type with [ClientIncludeModel] and
     * genclient will create a type in Build/Client/Contracts/DataProvider.d.ts.
     */
    public getData<T = { [key: string]: any }>(contributionId: string, routeValues?: { [key: string]: string }) {
        return this._service.getData<T>(contributionId, routeValues);
    }

    /**
     * @param T Type to retrieve from the contribution source.
     * Decorate your C# return type with [ClientIncludeModel] and
     * genclient will create a type in Build/Client/Contracts/DataProvider.d.ts.
     */
    public getSharedData<T = { [key: string]: any }>(sharedDataKey: string) {
        return this._service.getSharedData<T>(sharedDataKey);
    }

    /**
     * @param T Type to retrieve from the contribution source.
     * Decorate your C# return type with [ClientIncludeModel] and
     * genclient will create a type in Build/Client/Contracts/DataProvider.d.ts.
     */
    public getContributions<T>(contributionIds: string[]) {
        return Promise.all(contributionIds.map(id => this._service.getContributionAsync<T>(id)));
    }

    private get _service() {
        return this._pageContext.getService<IVssContributionService>("IVssContributionService");
    }
}
